<div class="modal-header">
  <h5 class="modal-title">ข้อมูลใบรับรองอิเล็กทรอนิกส์</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"
          [disabled]="uploading"></button>
</div>

<div class="modal-body">
  @if (loading) {
    <div class="empty-state">
      <div class="spinner-border text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="empty-state-text">กำลังโหลดข้อมูลใบรับรอง...</div>
    </div>
  } @else if (errorMessage) {
    <div class="alert alert-danger mb-0">{{ errorMessage }}</div>
  } @else {
    <div class="upload-panel mb-3">
      <div class="upload-text">
        อัปโหลดไฟล์ .p12 หรือ .pfx ระบบจะใช้ไฟล์ล่าสุดแทนไฟล์เดิม
      </div>
      <div class="upload-actions">
        <label class="upload-button">
          <input type="file" accept=".p12,.pfx" (change)="onCertificateSelected($event, certificatePasswordModal)"
                 [disabled]="uploading || previewing">
          <span>@if (previewing) {
            กำลังอ่านข้อมูล...
          } @else if (uploading) {
            กำลังอัปโหลด...
          } @else if (hasCertificateFile()) {
            อัปโหลดไฟล์ใหม่
          } @else {
            เลือกไฟล์ใบรับรอง
          }</span>
        </label>
        @if (selectedFile) {
          <span class="selected-file">{{ selectedFile.name }}</span>
        }
        @if (hasCertificateFile()) {
          <a class="download-button" href="javascript:void(0)" (click)="downloadCertificateFile()">
            ดาวน์โหลดไฟล์ปัจจุบัน
          </a>
        }
      </div>
      @if (uploadErrorMessage) {
        <div class="alert alert-warning mb-0">
          <div class="fw-semibold mb-1">บันทึกข้อมูลไม่สำเร็จ</div>
          <div>{{ uploadErrorMessage }}</div>
        </div>
      }
    </div>

    @if (previewing) {
      <div class="empty-state">
        <div class="spinner-border text-success" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="empty-state-text">กำลังอ่านข้อมูลใบรับรองจากไฟล์...</div>
      </div>
    } @else if (notFound || !displayCertificate()) {
      <div class="alert alert-info mb-0">
        ยังไม่มีไฟล์ใบรับรองอิเล็กทรอนิกส์ในระบบ
      </div>
    } @else {
      <div class="certificate-layout">
        <section class="certificate-card">
          <div class="section-title">Issued to</div>
          <div class="detail-grid">
            <div class="detail-label">Email</div>
            <div class="detail-value">{{ displayCertificate()!.subjectE || '-' }}</div>
            <div class="detail-label">CN</div>
            <div class="detail-value">{{ displayCertificate()!.subjectCn || '-' }}</div>
            <div class="detail-label">OU</div>
            <div class="detail-value">{{ displayCertificate()!.subjectOu || '-' }}</div>
            <div class="detail-label">O</div>
            <div class="detail-value">{{ displayCertificate()!.subjectO || '-' }}</div>
            <div class="detail-label">L</div>
            <div class="detail-value">{{ displayCertificate()!.subjectL || '-' }}</div>
            <div class="detail-label">C</div>
            <div class="detail-value">{{ displayCertificate()!.subjectC || '-' }}</div>
          </div>
        </section>

        <section class="certificate-card">
          <div class="section-title">Issued by</div>
          <div class="detail-grid">
            <div class="detail-label">CN</div>
            <div class="detail-value">{{ displayCertificate()!.issuerCn || '-' }}</div>
            <div class="detail-label">OU</div>
            <div class="detail-value">{{ displayCertificate()!.issuerOu || '-' }}</div>
            <div class="detail-label">O</div>
            <div class="detail-value">{{ displayCertificate()!.issuerO || '-' }}</div>
            <div class="detail-label">L</div>
            <div class="detail-value">{{ displayCertificate()!.issuerL || '-' }}</div>
            <div class="detail-label">C</div>
            <div class="detail-value">{{ displayCertificate()!.issuerC || '-' }}</div>
          </div>
        </section>

        <section class="certificate-card certificate-meta">
          <div class="section-title">@if (selectedFile) {
            ข้อมูลจากไฟล์ที่เลือก
          } @else {
            ข้อมูลในระบบ
          }</div>
          <div class="meta-row">
            <span class="meta-label">Valid from</span>
            <span
              class="meta-value">{{ displayCertificate()!.validFrom ? (displayCertificate()!.validFrom | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-label">Valid to</span>
            <span
              class="meta-value">{{ displayCertificate()!.validTo ? (displayCertificate()!.validTo | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-label">วันที่บันทึก</span>
            <span
              class="meta-value">{{ displayCertificate()!.createdTime ? (displayCertificate()!.createdTime | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-label">ชื่อไฟล์</span>
            <span class="meta-value">{{ displayCertificate()!.certificateFileName || '-' }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-label">ตำแหน่งไฟล์</span>
            <span class="meta-value path-value">{{ displayCertificate()!.certificateFile || '-' }}</span>
          </div>
        </section>
      </div>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-link" (click)="activeModal.close()" [disabled]="uploading || previewing">ปิด
  </button>
  <button type="button" class="btn btn-primary btn-custom" (click)="saveCertificate()"
          [disabled]="!selectedFile || uploading || previewing">บันทึก
  </button>
</div>

<ng-template #certificatePasswordModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">รหัสผ่านใบรับรองอิเล็กทรอนิกส์</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body">
    <p class="small text-body-secondary mb-3">ระบุรหัสผ่านสำหรับไฟล์ {{ selectedFile?.name }}</p>
    <label class="form-label form-label-sm" for="certificate-password">รหัสผ่าน</label>
    <input id="certificate-password"
           type="password"
           class="form-control"
           autocomplete="new-password"
           [(ngModel)]="certificatePassword"
           (keyup.enter)="submitCertificatePassword(modal)">
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-link text-decoration-none" (click)="modal.close()">ยกเลิก</button>
    <button type="button" class="btn btn-sm btn-primary" (click)="submitCertificatePassword(modal)">ตรวจสอบไฟล์</button>
  </div>
</ng-template>
